import { Role } from "../../types/role";

const STSan: Role = {
  primary: [
    "Abschluss",
    "Ballannahme",
    "Dribbling",
    "Technik",
    "Nervenstaerke",
    "OhneBall",
    "Antritt",
  ],
  secondary: [
    "Passen",
    "Antizipation",
    "Einsatzfreude",
    "Entscheidungen",
    "Ausdauer",
    "Balance",
    "Beweglichkeit",
    "Schnelligkeit",
  ],
  physis: "mittelfeld",
};

export const STS = {
  STSan,
};
